// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    tasks_find_tasks: 'Buscando entre las tareas',
    tasks_pending_on: 'Mirando qué queda pendiente ahí',
    tasks_complete_task: 'Marcando una tarea como hecha',
    tasks_create_task: 'Apuntando una tarea',
  },
  ca: {
    tasks_find_tasks: 'Cercant entre les tasques',
    tasks_pending_on: 'Mirant què queda pendent',
    tasks_complete_task: 'Marcant una tasca com a feta',
    tasks_create_task: 'Anotant una tasca',
  },
  en: {
    tasks_find_tasks: 'Looking through the tasks',
    tasks_pending_on: 'Checking what is outstanding there',
    tasks_complete_task: 'Ticking a task off',
    tasks_create_task: 'Writing a task down',
  },
  fr: {
    tasks_find_tasks: 'Recherche parmi les tâches',
    tasks_pending_on: 'Ce qui reste en suspens',
    tasks_complete_task: 'Validation d’une tâche',
    tasks_create_task: 'Création d’une tâche',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
